import { render, staticRenderFns } from "./OnboardingFacetecError.vue?vue&type=template&id=490ab7a6&scoped=true"
import script from "./OnboardingFacetecError.vue?vue&type=script&lang=js"
export * from "./OnboardingFacetecError.vue?vue&type=script&lang=js"
import style0 from "./OnboardingFacetecError.vue?vue&type=style&index=0&id=490ab7a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490ab7a6",
  null
  
)

export default component.exports